﻿import { IVmFilterValue } from "../Interface/IVmFilterValue";
export class VmFilterValue implements IVmFilterValue {

    constructor() {
        this.FilterName = "";
        this.FilterValue = "";
    }

    FilterName: string;
    FilterValue: string;
}
